import Banner from "./Banner";
import Services from "./Services";
import Designer from "./Designer";
import Recognition from "./Recognition";
import Faq from "./Faq";

export default function StartMyJourney() {
  return (
    <>
      <Banner />
      {/* <Message />
      <Brand />
      <Grace />
      <Exclusive />
      <Collection />
      <Videoslider />
      <Luxury />
      <Wedding />
      <Style /> */}
      <Services />
      <Designer />
      <Recognition />
      <Faq />
    </>
  );
}
